export default __webpack_public_path__ + "static/about_condo-64df419b21fb2817246bda8bc606436f.png";